import ModalV2 from "./ModalV2";

export * from "./ModalV2";

export default ModalV2;
